module.exports = __webpack_public_path__ + "static/media/ev-3.928dbc38.jpg";